


















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TrackSelectModal extends Vue {
  @Prop() readonly tracks!: any[];
  @Prop() readonly active!: any;

  selected: any = [];

  mounted() {
    this.selected = [...(this.active.tracks || this.active)];
  }

  done() {
    this.active.selected = this.selected;
    this.$emit('done', this.selected);
    this.$emit('close');
  }
}
